import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

interface BankAccountNumberMatchProps {
  originalBankAccountNumber?: string;
  analysis?: {
    bankAccountNumberMatch?: boolean;
    matchedBankAccountNumber?: string;
  };
}

const BankAccountNumberMatch: React.FC<BankAccountNumberMatchProps> = ({ originalBankAccountNumber, analysis }) => {
  const bankAccountMatched = !!(
    analysis?.bankAccountNumberMatch &&
    analysis?.matchedBankAccountNumber &&
    String(analysis?.matchedBankAccountNumber).trim() !== ''
  );
  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary">Bank Account Number Match</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip 
          label={bankAccountMatched ? 'Matched' : 'Not Matched'}
          color={bankAccountMatched ? 'success' : 'error'}
          size="small"
        />
      </Box>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Original: {originalBankAccountNumber || (
            <Box component="span" sx={{ color: 'warning.main', fontWeight: 'bold' }}>
              Not Supplied
            </Box>
          )}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Matched: {bankAccountMatched
            ? analysis?.matchedBankAccountNumber
            : 'No bank account number matched'}
        </Typography>
      </Box>
    </Box>
  );
};

export default BankAccountNumberMatch; 